import { CurrencyFormat } from "../../CurrencyFormat";
import styles from "./payment-methods.module.scss";

export const Bpay = ({ paymentInfo, commonData }) => (
  <>
    <div className={styles.headText}>
      To make a payment to this account, log on to your online banking
      institution and enter the BPAY biller details below.
    </div>
    <div role="table" className={styles.table}>
      <div role="row" className={styles.row}>
        <div role="cell" className={styles.label}>
          Biller code
        </div>
        <div role="cell">{paymentInfo.biller_code}</div>
      </div>
      <div role="row" className={styles.row}>
        <div role="cell" className={styles.label}>
          Reference number
        </div>
        <div role="cell">{commonData.accountNumber}</div>
      </div>
    </div>
    <div className="body03">
      {paymentInfo.fee && (
        <p>
          A payment of <CurrencyFormat value={paymentInfo.fee} /> applies.
        </p>
      )}

      <p>
        If you’re paying by BPAY on your due date, make sure you complete the
        transaction before the bank’s cut-off time. Remember that some BPAY
        payments can take up to 3 business days to clear.
      </p>
    </div>
  </>
);
